"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[169],{

/***/ 51237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AnimatedInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function AnimatedInput(_ref) {
  var isPress = _ref.isPress,
      type = _ref.type,
      name = _ref.name,
      required = _ref.required,
      children = _ref.children,
      onInputChange = _ref.onInputChange,
      area = _ref.area,
      value = _ref.value;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      active = _useState[0],
      setActive = _useState[1];

  function handleActivation(e) {
    onInputChange(e);
    setActive(!!e.target.value);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "relative border-b rounded mb-2 bg-gray-600 text-gray-50 border-black border-opacity-25 truncate ",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
      value: value,
      className: [area ? "pb-20" : "", "outline-none w-full rounded ".concat(isPress ? "bg-gray-5" : "bg-transparent", "  text-sm text-gray-80 transition-all duration-200 ease-in-out p-3"), active ? "pt-6" : ""].join(" "),
      id: name,
      name: name,
      type: type,
      onChange: handleActivation
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
      className: ["absolute top-0 left-0 flex items-center text-gray-50 text-opacity-50 p-2 transition-all duration-200 ease-in-out", active ? "text-xs" : "text-sm"].join(" "),
      htmlFor: name,
      children: [children, required && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        className: "flex items-center justify-center text-primary",
        children: "\xA0*"
      })]
    })]
  });
}

/***/ }),

/***/ 59181:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var Errors = {
  ERR_REFUND_ORDER_PROCESSING: "You have already requested a refund for this order",
  ERR_EMPLOYEE_ALREADY_EXISTS: "You already have a staff member with this info",
  ERR_UNAUTHORIZED: "Your credentials have expired, you need to log in again",
  ERR_ACCOUNT_BALANCE_LOW: "You don't have enough balance",
  ERR_ORDER_SETTLEMENT_PROCESSED: "Orders in which the settlement process has started cannot be refunded",
  ERR_LOGIN_CREDENTIALS: "Wrong email or password",
  ERR_PASSWORD_WRONG: "Wrong password",
  ERR_TWO_FA_ALREADY_ENABLED: "2fa already enabled",
  ERR_CONTACT_ID_INVALID: "Contact not found",
  ERR_ADDRESS_NOT_FOUND: "Address not generated yet, please contact support",
  ERR_VALIDATION: "Wrong details provided",
  ERR_EMAIL_NOT_FOUND: "Email not found",
  ERR_TWO_FA_CODE_INVALID: "2FA code is invalid or has expired. Please try again",
  UNKNOWN: "An unknown error occurred. Please try again in a few minutes. If the problem persists contact support",
  SUCCESS_LOGIN_OTP_VERIFICATION_CODE: "We sent a new code to your email address",
  ERR_CODE_ALREADY_SENT: "A code was already sent to your email.",
  ERR_VERIFICATION_CODE_INVALID: "Verification code is invalid or has expired. Please try again",
  VALIDATION_FAILED: "Please verify your email and password",
  ERR_EMAIL_OR_PASSWORD_WRONG: "Please verify your email and password",
  ERR_CAPTCHA_REQUIRED: "Please verify captcha to continue.",
  ERR_INVALID_CAPTCHA: "Invalid captcha",
  ERR_ORDER_REFUND_EXISTS: "This order has already been refunded",
  ERR_PHONE_ALREADY_EXISTS: "Phone number is already in use. Please verify or specify a new phone number.",
  ERR_EMAIL_ALREADY_EXISTS: "Email address is already in use. Please verify or specify a new email.",
  ERR_CUSTOMER_NOT_FOUND: "We could not find this email in our database. Please verify.",
  ERR_CUSTOMER_NAME_INVALID: "Name field can only contain a first and a last name.",
  ERR_TWO_FA_CODE: "2FA code is invalid or has expired. Please try again.",
  ERR_DEPOSIT_ADDRESS_REQUIRED: "Please verify that your deposit address is valid.",
  ERR_ORDER_PROCESSED: "Order with current state can't be refunded",
  ERR_PASSWORDS_NOT_MATCHING: "New passwords do not match. Please verify",
  ERR_AMOUNT_LOW: "Amount is less than minimum required",
  ERR_HAS_UNPAID_INVOICES: "You can't ask for new loan before paying active ones",
  ERR_NO_API_USERS: "You need to activate your API keys. Please contact support@datamynt.zendesk.com",
  ERR_NETWORK_NOT_SUPPORTED: "This network is currently not supported",
  ERR_INVALID_ADDRESS: "Please verify if all the added addresses are valid",
  ERR_ASSET_NOT_SWAPPABLE: "Asset is not swappable",
  ERR_INVOICE_NOT_PAID: "You cannot refund an invoice which is not yet paid",
  ERR_WITHDRAWAL_REQUEST_PENDING: "Withdrawal request can't be processed, while there is a pending withdrawal request",
  ERR_INVOICE_REFUND_EXISTS: "A refund has already been processed for this invoice",
  ERR_EXPORT_REQUEST_EXISTS: "We can't process this request as there is an existing export request",
  ERR_SETTLEMENT_ISSUE: "There is an issue with settlement. Please contact support for more details",
  ERR_FIAT_SETTLEMENT_RATE: "Rates are not available currently. Please contact support for more details",
  ERR_BANK_ACCOUNT: "There is a problem verifying bank account. Please contact support for more details",
  ERR_BANK_ACCOUNT_EXISTS: "Bank account details already exists",
  ERR_SETTLEMENT_AMOUNT: "Settlement amount can be >= 500 NGN and <= 10000000 NGN"
};
/* harmony default export */ __webpack_exports__["Z"] = (Errors);

/***/ }),

/***/ 68627:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var FormikErrorMsgs = {
  required: "This field is required",
  invalidEmail: "This is not a valid email",
  invalidPhone: "This is not a valid phone",
  wrongPassword: "Password needs to be at least 8 characters long and maximum of 24 characters. It also needs to include at least one number, one special character and one uppercase letter.",
  noSpecialChars: "No special chars are allowed in this field"
};
/* harmony default export */ __webpack_exports__["Z"] = (FormikErrorMsgs);

/***/ }),

/***/ 60650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7258);
/* harmony import */ var _formikErrorMsgs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68627);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82580);
/* harmony import */ var _AnimatedInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51237);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47965);
/* harmony import */ var reaptcha__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46944);
/* harmony import */ var react_phone_number_input_style_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15922);
/* harmony import */ var react_phone_number_input_style_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_phone_number_input_style_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_phone_number_input__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15034);
/* harmony import */ var _hooks_useErrorHandling__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59269);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);
















var Styles = {
  errorMsg: "text-red-primary text-sm"
};
var options = ["Add crypto as currency checkout or payments", "Become a partner or reseller"];

var Spinner = function Spinner() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
    src: "/loading.png",
    width: 20,
    height: 20,
    alt: "spinner"
  });
};

var validationSchema = yup__WEBPACK_IMPORTED_MODULE_1__.object().shape({
  email: yup__WEBPACK_IMPORTED_MODULE_1__.string().email(_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_2__/* ["default"].invalidEmail */ .Z.invalidEmail).required(_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_2__/* ["default"].required */ .Z.required),
  name: yup__WEBPACK_IMPORTED_MODULE_1__.string().required(_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_2__/* ["default"].required */ .Z.required),
  BusinessName: yup__WEBPACK_IMPORTED_MODULE_1__.string().required(_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_2__/* ["default"].required */ .Z.required),
  telegram: yup__WEBPACK_IMPORTED_MODULE_1__.string(),
  whatsApp: yup__WEBPACK_IMPORTED_MODULE_1__.string(),
  website: yup__WEBPACK_IMPORTED_MODULE_1__.string(),
  wantToPartnerOptions: yup__WEBPACK_IMPORTED_MODULE_1__.string().required(_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_2__/* ["default"].required */ .Z.required).oneOf(options, "Please select an option"),
  message: yup__WEBPACK_IMPORTED_MODULE_1__.string().required(_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_2__/* ["default"].required */ .Z.required),
  ReCAPTCHA: yup__WEBPACK_IMPORTED_MODULE_1__.string().required(_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_2__/* ["default"].required */ .Z.required)
});

var ContactUs = function ContactUs() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
    className: "pb-12 md:pb-44 space-y-6 flex flex-col items-center lg:items-start justify-center",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("h1", {
      className: "text-xl lg:text-5xl",
      children: "Contact Us"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
      className: "space-x-6",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
        href: "https://twitter.com/DataMynt",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            alt: "contact image",
            src: "/Twitternew.svg",
            width: 32,
            height: 32
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
        href: "mailto:sales@datamynt.com",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            alt: "contact image",
            src: "/Gmailnew.svg",
            width: 32,
            height: 32
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
        href: "https://wa.me/15104937072",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            alt: "contact image",
            src: "/Whatsappnew.svg",
            width: 32,
            height: 32
          })
        })
      })]
    })]
  });
};

var ContactUsForm = function ContactUsForm(_ref) {
  var _ref$isPress = _ref.isPress,
      isPress = _ref$isPress === void 0 ? false : _ref$isPress;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false),
      success = _useState[0],
      setSuccess = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useErrorHandling = (0,_hooks_useErrorHandling__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(),
      withErrorHandling = _useErrorHandling.withErrorHandling;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null),
      recaptchaRef = _useState4[0],
      setRecaptchaRef = _useState4[1];

  var resetForm = function resetForm() {
    formik.resetForm();
    setError(null);
  };

  var resetReCAPTCHA = function resetReCAPTCHA() {
    if (recaptchaRef) {
      recaptchaRef.reset();
    }
  };

  var formik = (0,formik__WEBPACK_IMPORTED_MODULE_3__/* .useFormik */ .TA)({
    initialValues: {
      name: "",
      email: "",
      website: "",
      whatsApp: "",
      BusinessName: "",
      wantToPartnerOptions: "",
      message: "",
      ReCAPTCHA: ""
    },
    validateOnChange: false,
    onSubmit: function () {
      var _onSubmit = (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var contactForm, requestBody;
        return _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestBody = {
                  name: values.name,
                  email: values.email,
                  businessName: values.BusinessName,
                  captcha: values.ReCAPTCHA,
                  message: values.message,
                  help: values.wantToPartnerOptions
                };

                if (values.website) {
                  requestBody.website = values.website;
                }

                if (values.whatsApp) {
                  requestBody.phone = values.whatsApp;
                }

                _context.prev = 3;
                _context.next = 6;
                return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_8__/* .apiContactRequestForm */ .J)(requestBody);

              case 6:
                contactForm = _context.sent;

                if (contactForm.status === 200) {
                  setError(null);
                  setSuccess(true);
                  setTimeout(function () {
                    resetForm();
                    setSuccess(false);
                    resetReCAPTCHA();
                  }, 500);
                }

                _context.next = 16;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                setError(_context.t0.response.data);
                _context.next = 15;
                return withErrorHandling(_helpers_api__WEBPACK_IMPORTED_MODULE_8__/* .apiContactRequestForm */ .J, requestBody, _context.t0.response.data);

              case 15:
                contactForm = _context.sent;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }(),
    validationSchema: validationSchema,
    enableReinitialize: true
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
    className: "mapBg",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
      className: "hidden lg:flex",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(ContactUs, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("form", {
      className: "flex flex-col h-full justify-between bg-white rounded-lg lg:rounded-none lg:mb-0 lg:rounded-t-lg shadow-lg p-7 md:p-10 w-full max-w-2xl lg:justify-self-end ",
      name: "contact",
      method: "POST",
      onSubmit: formik.handleSubmit,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("h1", {
        className: "text-black text-[24px] font-bold",
        children: "Please fill this form"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("input", {
        type: "hidden",
        name: "form-name",
        value: "contact"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_AnimatedInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isPress: true,
        value: formik.values.BusinessName,
        type: "text",
        name: "BusinessName",
        required: true,
        onInputChange: formik.handleChange,
        children: "Business Name"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
        className: formik.errors["BusinessName"] ? Styles.errorMsg : "hidden",
        children: formik.errors["BusinessName"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_AnimatedInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isPress: true,
        value: formik.values.email,
        type: "text",
        name: "email",
        required: true,
        onInputChange: formik.handleChange,
        children: "Email address"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
        className: formik.errors["email"] ? Styles.errorMsg : "hidden",
        children: formik.errors["email"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_AnimatedInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isPress: true,
        value: formik.values.name,
        type: "text",
        name: "name",
        required: true,
        onInputChange: formik.handleChange,
        children: "Name"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
        className: formik.errors["name"] ? Styles.errorMsg : "hidden",
        children: formik.errors["name"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_AnimatedInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isPress: true,
        value: formik.values.website,
        type: "text",
        name: "website",
        onInputChange: formik.handleChange,
        children: "Website if Available"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
        className: formik.errors["website"] ? Styles.errorMsg : "hidden",
        children: formik.errors["website"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        className: "border-b border-solid border-gray-30 py-2.5 text-sm  text-gray-80 rounded ",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_phone_number_input__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
          className: "input-phone-number",
          defaultCountry: "US",
          placeholder: "Enter WhatsApp Number",
          name: "whatsApp",
          value: formik.values.whatsApp,
          onChange: function onChange(e) {
            return formik.setFieldValue("whatsApp", e);
          }
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: "".concat(isPress ? "bg-transparent" : "bg-gray-5", " mb-2 rounded-lg flex flex-col space-y-2"),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
          className: "".concat(isPress ? "text-white" : "text-[#22242C]", " text-[16px] font-semibold mt-[24px]"),
          children: "How can we help your business grow?"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("select", {
            className: "w-full h-12 rounded-lg bg-transparent border-2 border-gray-5 text-[#22242C] font-semibold px-4 text-[16px]",
            name: "wantToPartnerOptions",
            onChange: formik.handleChange,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("option", {
              value: "",
              disabled: true,
              selected: true,
              children: "Please Select an option"
            }), options.map(function (option, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("option", {
                value: option,
                children: option
              }, index);
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
          className: formik.errors["wantToPartnerOptions"] ? Styles.errorMsg : "",
          children: formik.errors["wantToPartnerOptions"]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("textarea", {
          className: "w-full h-20 rounded-lg bg-transparent border-2 border-gray-5 text-[#22242C] font-semibold px-4   text-[16px]",
          name: "message",
          value: formik.values.message,
          placeholder: "What else can we help you with?",
          onChange: formik.handleChange
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
          className: formik.errors["message"] ? Styles.errorMsg : "",
          children: formik.errors["message"]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: "flex flex-col space-y-2 items-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(reaptcha__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          value: formik.values.ReCAPTCHA,
          sitekey:  true ? "6LfqUgwcAAAAAAABEclHKp9gQ4Y3b8SXpRRR7ST0" : 0,
          onVerify: function onVerify(ReCAPTCHA) {
            return formik.setFieldValue("ReCAPTCHA", ReCAPTCHA);
          },
          ref: function ref(e) {
            return setRecaptchaRef(e);
          },
          onChange: function onChange() {
            return resetReCAPTCHA(true);
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
          className: formik.errors["ReCAPTCHA"] ? Styles.errorMsg : "",
          children: formik.errors["ReCAPTCHA"]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: "flex flex-col items-center justify-center",
        children: [formik.isSubmitting ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(Spinner, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("button", {
          type: "submit",
          className: "bg-[#22242C] w-full px-8 py-2 text-white rounded-[38px] font-bold text-[16px] mt-[10px]",
          children: "Send"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
          className: formik.errors["check"] ? Styles.errorMsg : "",
          children: formik.errors["check"]
        })]
      }), success && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
        className: "text-primary",
        children: "Your info was sent successfully! We will get in touch shortly."
      }), error && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
        className: "text-primary",
        children: error.statusMessage
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
      className: "flex lg:hidden",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(ContactUs, {})
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ContactUsForm);

/***/ }),

/***/ 81519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var HeadComponent = function HeadComponent(_ref) {
  var SEO = _ref.SEO;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: SEO.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: SEO.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "og:title",
      content: SEO.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "og:description",
      content: SEO.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon/favicon-32x32.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon/favicon-16x16.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "manifest",
      href: "/favicon/site.webmanifest"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "mask-icon",
      href: "/favicon/safari-pinned-tab.svg",
      color: "#5bbad5"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "msapplication-TileColor",
      content: "#2b5797"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "theme-color",
      content: "#ffffff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "57x57",
      href: "/favicon/apple-icon-57x57.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "60x60",
      href: "/favicon/apple-icon-60x60.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "72x72",
      href: "/favicon/apple-icon-72x72.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "76x76",
      href: "/favicon/apple-icon-76x76.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "114x114",
      href: "/favicon/apple-icon-114x114.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "120x120",
      href: "/favicon/apple-icon-120x120.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "144x144",
      href: "/favicon/apple-icon-144x144.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "152x152",
      href: "/favicon/apple-icon-152x152.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "/favicon/apple-icon-180x180.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "192x192",
      href: "/favicon/android-icon-192x192.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon/favicon-32x32.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "96x96",
      href: "/favicon/favicon-96x96.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon/favicon-16x16.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "manifest",
      href: "/favicon/manifest.json"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "msapplication-TileColor",
      content: "#ffffff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "msapplication-TileImage",
      content: "/ms-icon-144x144.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "theme-color",
      content: "#ffffff"
    }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "title",
      content: SEO.title
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (HeadComponent);

/***/ }),

/***/ 59269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_errors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59181);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






var useErrorHandling = function useErrorHandling() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      error = _useState[0],
      setError = _useState[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var withErrorHandling = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(apiCall) {
      var _len,
          params,
          _key,
          _yield$apiCall,
          data,
          _err$response,
          _err$response$data,
          _err$response2,
          _err$response2$data,
          ignoredErrors,
          statusCode,
          statusMessage,
          _window$Rollbar,
          message,
          _args = arguments;

      return _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              for (_len = _args.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                params[_key - 1] = _args[_key];
              }

              _context.next = 4;
              return apiCall.apply(void 0, params);

            case 4:
              _yield$apiCall = _context.sent;
              data = _yield$apiCall.data;
              setError(null);
              return _context.abrupt("return", {
                data: data,
                error: null
              });

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              // Status codes listed here should be expected errors (i.e wrong password token expiration etc)
              ignoredErrors = ["ERR_UNAUTHORIZED", "ERR_PASSWORD_WRONG", "ERR_LOGIN_CREDENTIALS"];
              statusCode = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.statusCode;
              statusMessage = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response2 = _context.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.statusMessage;

              if (!(statusCode === "ERR_UNAUTHORIZED" || statusCode === "ERR_FORBIDDEN")) {
                _context.next = 18;
                break;
              }

              _context.next = 18;
              return router.push("/login");

            case 18:
              if ( true && (!statusCode || !ignoredErrors.includes(statusCode))) {
                (_window$Rollbar = window.Rollbar) === null || _window$Rollbar === void 0 ? void 0 : _window$Rollbar.error(_context.t0);
              }

              if (false) {}

              message = statusCode === "ERR_INVALID_ADDRESS" ? statusMessage : _components_errors__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[statusCode];
              message && setError(message);
              return _context.abrupt("return", {
                error: {
                  statusCode: statusCode,
                  message: message
                }
              });

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  return {
    error: error,
    setError: setError,
    withErrorHandling: withErrorHandling
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useErrorHandling);

/***/ }),

/***/ 35546:
/***/ (function(module) {

module.exports = JSON.parse('{"title":"The Future of Business Banking & Payments","description":"On-Chain Financial Infrastructure For Today’s Businesses"}');

/***/ })

}]);